import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { IconChevronRightSmall } from '@sololearnorg/sol';

import { ActionType, RequestType } from '../../../global-interface';
import { SlLEContext } from '../../../global-constants';
import { SlActions } from '../../../services/ActionsService/sl-actions';
import { ISlLoginResponse, SlLogin } from '../../../../../login/public/SlLogin/SlLogin';
import { LocalizedLink } from '../../../../../shared/public/LocalizedLink/LocalizedLink';
import { IError, ErrorCodes } from '../../../../../api/private/global.interface';
import { ILPHeaderData } from '../../../../../api/private/learn-engine-api/landing-page-api.interface';
import { Container, i18n } from '../../../../../symphony';

import s from './LandingPageHeader.scss';
import { getEnvironment } from '../../../../../../client/utils/environment';
import { openAIFlow } from '../../../../../../client/utils/openAIFlow';

interface ILandingPageHeaderProps {
  data: ILPHeaderData;
  alias: string;
}

export function LandingPageHeader({
  data,
  alias,
}: ILandingPageHeaderProps): JSX.Element {
  useStyles(s);
  const { headerInfo } = data;

  const isAiEnvironment = getEnvironment().includes('ai');

  const loginCallback = (res: ISlLoginResponse) => {
    const { actions$ } = Container.take(SlLEContext, SlActions);

    actions$.next({
      type: ActionType.OnLandingSignup,
      requestType: RequestType.Parallel,
      data: {
        isNewRegistered: res.res.user.isNewRegisteredUser,
      },
    });
  };

  const onLoginError = (err: IError): void => {
    console.error(err);
  };

  return (
    <header className="lp-landing-page-header">
      <div className="lp-landing-page-header__main">
        <div className="lp-landing-page-header__breadcrumb">
          <LocalizedLink to="/learn">
            {i18n.t('web-lelp.breadcrumb-courses')}
          </LocalizedLink>
          <IconChevronRightSmall
            size={16}
            className="lp-landing-page-header__breadcrumb__icon"
          />
          <p className="lp-landing-page-header__breadcrumb__title">
            {i18n.t(`web-lelp.${alias}-headerinfo-title`)}
          </p>
        </div>
        <div className="lp-landing-page-header__info-wrapper">
          <div className="lp-landing-page-header__info">
            <div className="lp-landing-page-header__image">
              <img src={headerInfo.courseLogo} alt="course" />
            </div>
            <h1 className="lp-landing-page-header__title">
              {i18n.t(`web-lelp.${alias}-headerinfo-title`)}
            </h1>
            <p className="lp-landing-page-header__description">
              {i18n.t(`web-lelp.${alias}-headerinfo-description`)}
            </p>
          </div>
        </div>
        <div className="lp-landing-page-header__signup-wrapper">
          {!isAiEnvironment ? <SlLogin
            useRouter={false}
            defaultRoute="signup"
            loginCallback={loginCallback}
            loginErrorHandler={{
              [ErrorCodes.TooManyRequests]: onLoginError,
            }}
            contextOptions={{
              shouldDefaultRedirect: false,
            }}
            cssClass="lp-landing-page-header__signup"
            signupTitle={i18n.t(`web-lelp.${alias}-signup-title`)}
            description={i18n.t(
              `web-lelp.${alias}-signup-description`,
            )}
            isLandingPage
          /> : <button
            className="lp-landing-page-header__signup-button"
            onClick={openAIFlow}
          >{i18n.t('ai-home.start-learning-ai')}</button>}
        </div>
      </div>
      <div className="lp-landing-page-header__illustration">
        <img
          src="https://lecontent.sololearn.com/static-pages/angular/hero_bg.svg"
          alt="Angular hero"
        />
      </div>
    </header>
  );
}
